function numberFormat(number: number | string, decimal?: number): string {
  let option = {};
  if (decimal) {
    option = { maximumFractionDigits: decimal };
  }
  const result = Number(number) ? new Intl.NumberFormat('en-US', option).format(Number(number)) : number.toString();
  return result;
}

export default numberFormat;
